export default "__VITE_ASSET__DaEVDHa4__"